import { NSFW_GATING_REASONS } from "../features/constants";
import { isAgeVerificationMandatory } from "./isAgeVerificationMandatory";
export const getNsfwGatingReason = (onlyUserId = null, ageVerificationStatus) => {
    if (!onlyUserId) {
        return NSFW_GATING_REASONS.GUEST_ACCESS_LIMITED;
    }
    if (isAgeVerificationMandatory(ageVerificationStatus)) {
        return NSFW_GATING_REASONS.AGE_VERIFICATION_REQUIRED;
    }
    return null;
};
